export default {
  type: 'select',
  name: '下拉框',
  components: 'HSelect',
  icon: '',
  tips: '下拉列表框，可配置多选，可关联标签库。',
  configList: ['BasicConfig', 'SelectConfig', 'RuleConfig'],
  options: {}
}
